// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseHref: "",
  //apiUrl: 'http://api.e-litigation.admincourt.app.unigainfo.com/api/v1'

   // apiUrl: 'https://elitigationdev.admincourt.go.th/new-api-demo/api/v1',
    //apiUrl: 'http://localhost:5191/api/v1',
    apiUrlV2: 'http://10.10.10.23:5191/api/v1',
    //apiUrlV2: 'http://10.10.10.27:5191/api/v1', ใช้ไม่ได้
    apiUrl: 'https://eliback.admincourt.go.th/api/v1',
    apiNotiSystemUrl:'https://eliback.admincourt.go.th/api/v1'//เครื่อง eadmin 27
 
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
